// extracted by mini-css-extract-plugin
module.exports = {"main_body":"MarketPlace_main_body__2Vzr9","tab":"MarketPlace_tab__3Wd4O","market_tab":"MarketPlace_market_tab__1ClEL","main_div":"MarketPlace_main_div__3XbkP"};